<template>
    <div>
        <Header />
        <Company />
        <div v-if="$store.state.hostName !== 'Q'">
            <Footer />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Company from '@/components/Company.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'CompanyView',

  components: {
    Header,
    Company,
    Footer
  }
}
</script>
